import {Component} from '@angular/core';
import {MatCardModule} from '@angular/material/card';

@Component({
    standalone: true,
    selector: 'app-app-mobile-prod',
    templateUrl: './app-mobile-prod.component.html',
    styleUrls: ['./app-mobile-prod.component.scss'],
    imports: [MatCardModule]
})
export class AppMobileProdComponent {}
